import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomControlSet, CustomControl } from './template-provider.model';
import { Observable, map, tap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class TemplateProviderService
{
    customControls: CustomControlSet = {};
    static customControlsUrl = "./custom-controls.json";

    constructor(private _http: HttpClient) {
    }

    loadCustomControls(): Observable<CustomControlSet> {
        return this._http.get(TemplateProviderService.customControlsUrl).pipe(
            tap(data => {
                if (!Array.isArray(data)) {
                    return;
                }

                data.forEach((item) => {
                    if (!!item["controlName"] && !!item["componentClassName"]) {
                        let customControlSpec: CustomControl = {
                            componentClassName: item["componentClassName"],
                            validControlTypes: []
                        }
                        if (!!item["validControlTypes"]) {
                            customControlSpec.validControlTypes = typeof item["validControlTypes"] === 'string' ? [item["validControlTypes"]] : item["validControlTypes"] || [];
                        }

                        this.customControls[item["controlName"]] = customControlSpec;
                    }
                });
            }),
            map((data) => {
                return this.customControls;
            })
        );
    }

    findCustomControl(controlType, controlNameOverride): CustomControl {
        for (var key in this.customControls) {
            if (Object.hasOwn(this.customControls, key)) {
                var customControl = this.customControls[key];
                if (customControl.validControlTypes.length > 0) {
                    if (!customControl.validControlTypes.includes(controlType)) {
                        continue;
                    }
                }

                var regVal = key.replace('*', '.*'),
                    reg = new RegExp(regVal, 'i');

                if (reg.test(controlNameOverride)) {
                    return customControl;
                }
            }
        }

        return null;
    }
}
